import { useEffect, useState } from "react"
import { IPickList } from "../../../List/RecallsPickList"
import { FoundStatusSmartEnum } from "../../../../../enums/Domain/FoundStatusSmartEnum"
import SidePanelRecallPickListLocationSummary from "../components/SidePanelRecallPickListLocationSummary"
import { httpGet } from "../../../../../modules/Backend"
import SidePanelInfo from "../components/SidePanelInfo"
import PrintRecallPickList from "../../../print/PrintRecallPickList"
import { StatusDto } from "../../../../../enums/Domain/Status"
import useRecallPickListActions from "../../../picking/useRecallPickListActions"
import RecallPickingButtons from "../../../picking/RecallPickingButtons"
import { EntityNames } from "../../../../../enums/EntityNames"
import SidePanelAddressAccordion from "../components/SidePanelAddressAccordion"

export default function SidePanelRecallPickList({ recallId, items }: IPickList) {

    const [data, setData] = useState<any>();
    const { save, submit, cancel } = useRecallPickListActions({
        recallId,
        items
    });
    const [canRender, setCanRender] = useState<boolean>(false);
    
    async function getData() {
        setCanRender(false)
        const result = await httpGet(`api/${EntityNames.recalls}/get?id=${recallId}`)
        if (result.data) {
            setData(result.data)
        }
        setCanRender(true)
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <div className="display--flex flex__direction--column height--full">
            <div className="display--flex alignItems--end gap--xs">
                <h2>Recall {data?.reference}</h2>
            </div>
            <div className="display--flex gap--s flex__wrap--wrap margin__top--s">
                <PrintRecallPickList recallId={recallId} save={save} />
            </div>
                <SidePanelInfo
                    values={[
                        { label: "Request Type", value: data?.requestType },
                        { label: "Account", value: data?.accountName },
                        { label: "Client Ref", value: data?.orderNumber }
                    ]}
                    canRender={canRender}
                />
                <SidePanelAddressAccordion title="Delivery address" address={data?.deliveryAddress} />
                <SidePanelAddressAccordion title="Invoice address" address={data?.invoiceAddress} />
            <SidePanelRecallPickListLocationSummary recallId={recallId} />
            <div className="margin__top--auto">
                <RecallPickingButtons save={save} submit={submit} cancel={cancel} lineItems={items} />
            </div>
        </div>
    )
}

export function getFoundStatusFromQuantity(quantity: number | undefined | null): StatusDto {
    if (quantity === undefined || quantity === null) {
        return new StatusDto(FoundStatusSmartEnum.Undecided.value, FoundStatusSmartEnum.getName());
    } else if (quantity === 0) {
        return new StatusDto(FoundStatusSmartEnum.NotFound.value, FoundStatusSmartEnum.getName());
    } else if (quantity > 0) {
        return new StatusDto(FoundStatusSmartEnum.Confirmed.value, FoundStatusSmartEnum.getName());
    } else {
        return new StatusDto(FoundStatusSmartEnum.Undecided.value, FoundStatusSmartEnum.getName());
    }
}

